export enum payoutStatus {
  processing = "processing",
  successful = "successful",
  failed = "failed",
  // refunded = "refunded",
}
